import React, { ReactNode } from "react"

import "./style.scss"

interface SpeechBubbleProps {
  image: string
  /** Nom du personnage qui parle : sert d'alternative textuelle à l'image */
  speaker: string
  /** Réplique : du texte, éventuellement avec des mots mis en valeur (`<strong>`) */
  message: ReactNode
  /** Bulle orientée vers la droite (personnage placé à droite) */
  isReversed?: boolean
  /** Id du texte, pour pouvoir l'utiliser comme intitulé d'une modale */
  messageId?: string
}

/** Personnage illustré accompagné de sa réplique dans une bulle */
const SpeechBubble = ({
  image,
  speaker,
  message,
  isReversed = false,
  messageId,
}: SpeechBubbleProps) => (
  <div className={`dc-speech${isReversed ? " is-reversed" : ""}`}>
    <img className="dc-speech__image" src={image} alt={speaker} />
    <p className="dc-speech__bubble" id={messageId}>
      {message}
    </p>
  </div>
)

export default SpeechBubble
